module.exports = __webpack_public_path__ + "img/icon-magicglass-gradient.060c4990.svg";